/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RequestPasswordResetRouteImport } from './routes/request-password-reset'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ChecklistRunsRouteImport } from './routes/checklist-runs'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChecklistRunsIndexRouteImport } from './routes/checklist-runs/index'
import { Route as ChecklistRunsRunIdRouteImport } from './routes/checklist-runs/$runId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestPasswordResetRoute = RequestPasswordResetRouteImport.update({
  id: '/request-password-reset',
  path: '/request-password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ChecklistRunsRoute = ChecklistRunsRouteImport.update({
  id: '/checklist-runs',
  path: '/checklist-runs',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChecklistRunsIndexRoute = ChecklistRunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChecklistRunsRoute,
} as any)
const ChecklistRunsRunIdRoute = ChecklistRunsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => ChecklistRunsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/checklist-runs': typeof ChecklistRunsRouteWithChildren
  '/login': typeof LoginRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/checklist-runs/$runId': typeof ChecklistRunsRunIdRoute
  '/checklist-runs/': typeof ChecklistRunsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/checklist-runs/$runId': typeof ChecklistRunsRunIdRoute
  '/checklist-runs': typeof ChecklistRunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/checklist-runs': typeof ChecklistRunsRouteWithChildren
  '/login': typeof LoginRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/checklist-runs/$runId': typeof ChecklistRunsRunIdRoute
  '/checklist-runs/': typeof ChecklistRunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/checklist-runs'
    | '/login'
    | '/request-password-reset'
    | '/reset-password'
    | '/checklist-runs/$runId'
    | '/checklist-runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/request-password-reset'
    | '/reset-password'
    | '/checklist-runs/$runId'
    | '/checklist-runs'
  id:
    | '__root__'
    | '/'
    | '/checklist-runs'
    | '/login'
    | '/request-password-reset'
    | '/reset-password'
    | '/checklist-runs/$runId'
    | '/checklist-runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChecklistRunsRoute: typeof ChecklistRunsRouteWithChildren
  LoginRoute: typeof LoginRoute
  RequestPasswordResetRoute: typeof RequestPasswordResetRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-password-reset': {
      id: '/request-password-reset'
      path: '/request-password-reset'
      fullPath: '/request-password-reset'
      preLoaderRoute: typeof RequestPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checklist-runs': {
      id: '/checklist-runs'
      path: '/checklist-runs'
      fullPath: '/checklist-runs'
      preLoaderRoute: typeof ChecklistRunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checklist-runs/': {
      id: '/checklist-runs/'
      path: '/'
      fullPath: '/checklist-runs/'
      preLoaderRoute: typeof ChecklistRunsIndexRouteImport
      parentRoute: typeof ChecklistRunsRoute
    }
    '/checklist-runs/$runId': {
      id: '/checklist-runs/$runId'
      path: '/$runId'
      fullPath: '/checklist-runs/$runId'
      preLoaderRoute: typeof ChecklistRunsRunIdRouteImport
      parentRoute: typeof ChecklistRunsRoute
    }
  }
}

interface ChecklistRunsRouteChildren {
  ChecklistRunsRunIdRoute: typeof ChecklistRunsRunIdRoute
  ChecklistRunsIndexRoute: typeof ChecklistRunsIndexRoute
}

const ChecklistRunsRouteChildren: ChecklistRunsRouteChildren = {
  ChecklistRunsRunIdRoute: ChecklistRunsRunIdRoute,
  ChecklistRunsIndexRoute: ChecklistRunsIndexRoute,
}

const ChecklistRunsRouteWithChildren = ChecklistRunsRoute._addFileChildren(
  ChecklistRunsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChecklistRunsRoute: ChecklistRunsRouteWithChildren,
  LoginRoute: LoginRoute,
  RequestPasswordResetRoute: RequestPasswordResetRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
